import { BreakpointObserver } from "@angular/cdk/layout";
import { Component, DestroyRef, effect, inject, OnInit } from "@angular/core";
import { takeUntilDestroyed, toSignal } from "@angular/core/rxjs-interop";
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";
import { RouterOutlet } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { map, shareReplay } from "rxjs/operators";
import { AppService } from "./store/app.service";

@Component({
    selector: "jobimag-root",
    imports: [RouterOutlet],
    templateUrl: "./app.template.html"
})
export class AppComponent implements OnInit {
    private readonly appService = inject(AppService);
    private readonly breakpointObserver = inject(BreakpointObserver);
    private readonly destroyRef = inject(DestroyRef);
    private readonly toastr = inject(ToastrService);

    private readonly isDesktop$ = this.breakpointObserver.observe("(width >= 48rem)").pipe(
        map((breakpoint) => breakpoint.matches),
        shareReplay()
    );

    private readonly isDesktop = toSignal(this.isDesktop$, { initialValue: false });

    constructor(
        private readonly iconRegistry: MatIconRegistry,
        private readonly sanitizer: DomSanitizer
    ) {
        this.iconRegistry.addSvgIconSetInNamespace(
            "streamline-regular",
            this.sanitizer.bypassSecurityTrustResourceUrl("assets/icons/regular.svg")
        );
        this.iconRegistry.addSvgIconSetInNamespace(
            "streamline-bold",
            this.sanitizer.bypassSecurityTrustResourceUrl("assets/icons/bold.svg")
        );

        effect(() => {
            this.toastr.toastrConfig.positionClass = this.isDesktop() ? "toast-bottom-right" : "toast-bottom-center";
        });
    }

    public ngOnInit(): void {
        this.appService.loadServerState().pipe(takeUntilDestroyed(this.destroyRef)).subscribe();
    }
}
